export const markupType = {
    PRODUCT: 'PRODUCT',
    DECORATION: 'DECORATION',
    ADDITIONAL_COST: 'ADDITIONAL_COST',
};
